import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Movies } from '../../models';

interface MovieListState {
    movies: Movies[];
    hasActiveFilter: boolean;
    loading: boolean;
}

const initialState: MovieListState = {
    movies: [],
    hasActiveFilter: false,
    loading: false
};

const movieListSlice = createSlice({
    name: 'movieList',
    initialState,
    reducers: {
        setMostRated: (state, action: PayloadAction<Movies | Movies[]>) => {
            state.movies = Array.isArray(action.payload) ? action.payload : [action.payload];
            state.hasActiveFilter = true;
        },
        setQueryMovie: (state, action: PayloadAction<Movies | Movies[]>) => {
            state.movies = Array.isArray(action.payload) ? action.payload : [action.payload];
            state.hasActiveFilter = true;
        },
        clearFilters: (state) => {
            state.movies = [];
            state.hasActiveFilter = false;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        }
    }
});

export const { setMostRated, setQueryMovie, clearFilters, setLoading } = movieListSlice.actions;
export const movieListReducer = movieListSlice.reducer;